<div class="row mt-2 px-1">
    <div class="col-12 col-lg-6 col-md-6">
        <p class="m-0 p-0">
            <strong> {{ 'daily-review.cash-payments' | translate }}: </strong>
        </p>
        <table class="table table-hover">
            <tbody *ngIf="paySafePayment.cashPaymentOrders?.length > 0; else noresults">
                <tr
                    *ngFor="
                        let cashPaymentOrder of paySafePayment.cashPaymentOrders;
                        index as i
                    "
                >
                    <th scope="row">{{ i + 1 }}</th>
                    <td>
                        <span>{{ cashPaymentOrder.orderCode }}</span>
                    </td>
                    <td>
                        {{ cashPaymentOrder.amount | priceround }}
                        {{ 'common.currency' | translate }}
                    </td>
                </tr>
                <tr>
                    <th></th>
                    <td>
                        <strong>{{ 'collecting.total' | translate }}</strong>
                    </td>
                    <td>
                        {{ paySafePayment.amount | priceround }}
                        {{ 'common.currency' | translate }}
                    </td>
                </tr>
                <tr>
                    <th></th>
                    <td></td>
                    <td>
                        <button
                            [disabled]="clickOnPaySafeButton"
                            (click)="openPaySafePaymentUrlInBrowser()"
                        >
                            {{ 'daily-review.paysafe-payment-button-title' | translate }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<ng-template #noresults>
    <tbody>
        <tr>
            <td colspan="3">No results found.</td>
        </tr>
    </tbody>
</ng-template>
